import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetHealthInsurance from './met-health-insurance';
import MetHealthInsuranceDetail from './met-health-insurance-detail';
import MetHealthInsuranceUpdate from './met-health-insurance-update';
import MetHealthInsuranceDeleteDialog from './met-health-insurance-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetHealthInsuranceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetHealthInsuranceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetHealthInsuranceDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetHealthInsurance} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetHealthInsuranceDeleteDialog} />
  </>
);

export default Routes;
